<template>
  <div :id="playerTargetId"></div>
</template>

<script setup lang="ts">
import type { StrapiMediaGalleryVideoItem } from '~/apollo/types/types';
import useYoutubeVideo from '~/composables/video/useYoutube';

const props = withDefaults(
  defineProps<{
    isActive?: boolean;
    video: StrapiMediaGalleryVideoItem;
    width: number;
    height: number;
  }>(),
  {
    isActive: false,
  },
);

const emit = defineEmits<{
  (e: 'video-loaded', isLoaded: boolean): void;
}>();

const { playerTargetId, isLoaded, loadVideo, stopVideo } = useYoutubeVideo(
  toRef(props, 'video'),
);

const width = toRef(props, 'width');
const height = toRef(props, 'height');

watch(
  () => props.isActive,
  (newValue) => {
    if (!newValue) {
      stopVideo();
    }
  },
);

watch(
  () => isLoaded.value,
  (newValue) => {
    emit('video-loaded', newValue);
  },
);

defineExpose({
  loadVideo: () => loadVideo(width, height),
});
</script>

<style lang="scss" scoped></style>
